import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { SharedCost, SharedCostFormData } from './types';

interface SharedCostDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  editingSharedCost: SharedCost | null;
  form: SharedCostFormData;
  onFormChange: (form: SharedCostFormData) => void;
  onSave: () => void;
}

export function SharedCostDialog({
  open,
  onOpenChange,
  editingSharedCost,
  form,
  onFormChange,
  onSave
}: SharedCostDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{editingSharedCost ? 'Redigera delad kostnad' : 'Ny delad kostnad'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Namn *</Label>
            <Input
              value={form.name}
              onChange={(e) => onFormChange({ ...form, name: e.target.value })}
              placeholder="T.ex. Trappstädning"
              data-testid="shared-cost-name-input"
            />
          </div>
          <div>
            <Label>Beskrivning</Label>
            <Input
              value={form.description}
              onChange={(e) => onFormChange({ ...form, description: e.target.value })}
              data-testid="shared-cost-description-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Totalbelopp (kr) *</Label>
              <Input
                type="number"
                value={form.total_amount}
                onChange={(e) => onFormChange({ ...form, total_amount: e.target.value })}
                data-testid="shared-cost-amount-input"
              />
            </div>
            <div>
              <Label>Period</Label>
              <Input
                type="month"
                value={form.period}
                onChange={(e) => onFormChange({ ...form, period: e.target.value })}
                data-testid="shared-cost-period-input"
              />
            </div>
          </div>
          <div>
            <Label>Fördelningsmetod</Label>
            <Select
              value={form.distribution_method}
              onValueChange={(value: 'equal' | 'by_sqm' | 'by_shares') => 
                onFormChange({ ...form, distribution_method: value })
              }
            >
              <SelectTrigger data-testid="shared-cost-distribution-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="equal">Lika fördelning</SelectItem>
                <SelectItem value="by_sqm">Per kvadratmeter</SelectItem>
                <SelectItem value="by_shares">Per andelstal</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="cost-include"
              checked={form.is_included_in_invoice}
              onChange={(e) => onFormChange({ ...form, is_included_in_invoice: e.target.checked })}
              data-testid="shared-cost-include-checkbox"
            />
            <label htmlFor="cost-include" className="text-sm">Inkludera i faktura</label>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Avbryt</Button>
          <Button onClick={onSave} data-testid="shared-cost-save-btn">Spara</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
